const textConstants = {
    NO_SERVICES_ON_RO_FOUND: 'No services found for this repair order. Go to repair order page for more details.',
    NO_SERVICE_HISTORY_FOUND: 'No service history found for this vehicle.',
    INSPECTION_DETAILS: 'Inspection Details',
};

export default textConstants;
